/**
 * AuditFilterBar Component
 * Filter bar for audit trail with date range picker
 */

import React from 'react';
import { DatePicker } from 'antd';
import { colors, spacing } from '../../../theme/designTokens';

const { RangePicker } = DatePicker;

function AuditFilterBar({ dateRange, onDateRangeChange }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: spacing.md,
      }}
    >
      <span style={{ fontWeight: 500, color: colors.text.primary, whiteSpace: 'nowrap' }}>
        Date Range:
      </span>
      <RangePicker
        value={dateRange}
        onChange={onDateRangeChange}
        style={{ width: 320 }}
        format="YYYY-MM-DD"
        placeholder={['Start date', 'End date']}
      />
    </div>
  );
}

export default AuditFilterBar;
